module.exports = __webpack_public_path__ + "static/media/group.f85b9b18.png";